import { ROUTES } from "@/setup/frontend/routes";

export function buildFreshAuthLoginUrl(
	location: Pick<Location, "pathname" | "search">,
): string {
	const searchParams = new URLSearchParams({
		type: "provider",
		redirect: `${location.pathname}${location.search}`,
	});
	return `${ROUTES.LOGIN.ROOT}?${searchParams.toString()}`;
}
